module.exports = __webpack_public_path__ + "static/media/random.962401c9.svg";